import type { ShapeBuildPhase } from "@aprao/model/src/shapes/ShapeBuildPhase.js";

export const buildBuildPhaseName = (
  phase: ShapeBuildPhase,
  phases: Array<ShapeBuildPhase>,
) => {
  if (phase.name.length === 0) {
    return phases.length > 1 ?
        `Build phase ${phases.indexOf(phase) + 1}`
      : "Main build phase";
  }

  return phase.name;
};
